var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderCreateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_12447_122726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10.3333C0 4.62639 4.62639 0 10.3333 0V0C16.0403 0 20.6667 4.62639 20.6667 10.3333V10.3333C20.6667 16.0403 16.0403 20.6667 10.3333 20.6667V20.6667C4.62639 20.6667 0 16.0403 0 10.3333V10.3333Z",
    fill: "#D6F4DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.333 0.166992C15.9478 0.166992 20.4998 4.71826 20.5 10.333C20.5 15.9479 15.9479 20.5 10.333 20.5C4.71826 20.4998 0.166992 15.9478 0.166992 10.333C0.167168 4.71837 4.71837 0.167168 10.333 0.166992Z",
    stroke: "#C2EECD",
    strokeWidth: 0.333333
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12447_122726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3346 9.50065V12.0007M9.08464 10.7507H11.5846M13.668 13.6673C13.889 13.6673 14.1009 13.5795 14.2572 13.4232C14.4135 13.267 14.5013 13.055 14.5013 12.834V8.66732C14.5013 8.4463 14.4135 8.23434 14.2572 8.07806C14.1009 7.92178 13.889 7.83398 13.668 7.83398H10.3763C10.2369 7.83535 10.0994 7.80174 9.97643 7.73623C9.85341 7.67071 9.74879 7.57539 9.67214 7.45898L9.33464 6.95898C9.25876 6.84376 9.15546 6.74918 9.03401 6.68373C8.91256 6.61828 8.77676 6.58401 8.6388 6.58398H7.0013C6.78029 6.58398 6.56833 6.67178 6.41205 6.82806C6.25577 6.98434 6.16797 7.1963 6.16797 7.41732V12.834C6.16797 13.055 6.25577 13.267 6.41205 13.4232C6.56833 13.5795 6.78029 13.6673 7.0013 13.6673H13.668Z",
    stroke: "#155024",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_12447_122726",
    x: 0,
    y: 0,
    width: 20.666,
    height: 20.666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.487765 0 0 0 0 0.870746 0 0 0 0 0.581284 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_12447_122726"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12447_122726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(5.33398 5.33398)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderCreateIcon);
export default __webpack_public_path__ + "static/media/folder-create-icon.d656ad293e58104bf18845a7bbd6472a.svg";
export { ForwardRef as ReactComponent };